const getDigitsForMasking = (length) => {
  let digits = ""
  for (let index = 0; index < length; index++) {
    digits += "9"
  }
  return digits
}

const scapeForMask = (suffix) => {
  let scape = suffix.replaceAll("a", "\\a")
  scape = scape.replaceAll("9", "\\9")
  scape = scape.replaceAll("*", "\\*")

  return scape
}

const getMaskForQuantity = (digits, maskSuffix) => {
  return `${digits} ${scapeForMask(maskSuffix)}`
}

export { getDigitsForMasking, getMaskForQuantity }
